<ng-container>
    <mat-toolbar>
        <div class="toTheRight">{{ 'pages.mitarbeiterverwaltung.title' | translate }}</div>
      <app-mitarbeiter-filter #mitarbeiterFilter class="filter"></app-mitarbeiter-filter>
      <div class="add-button-container">
        <button matTooltip="Mitarbeiter Hinzufügen" *ngIf="(showAdd | async)" mat-mini-fab color="warn" aria-label="Add a address" class="pluscolor" (click)="addMitarbeiter();">
          <mat-icon>add</mat-icon>
        </button>
      </div>

    </mat-toolbar>

</ng-container>
<div class="page-content">
<app-mitarbeiter-table
  [mitarbeiter]="$mitarbeiter | async"
  [showFunctionMenu]="functionMenuEnabled"
  (editMitarbeiter)="editPersonalien($event);"
  (deleteMitarbeiter)="deletePersonalien($event);"
  (reactivateMitarbeiter)="reactivatePersonalien($event);"
>
</app-mitarbeiter-table>
</div>
